import PropTypes from 'prop-types';
import {pdfjs} from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url,
).toString();

//
export const OEPDFViewScaleMode = {
    explicit:                       'explicit',
    scale:                          'scale'
};

OEPDFViewScaleMode.all = Object.keys(OEPDFViewScaleMode);

//
export const OEPDFViewPageRenderMode = {
    none:                           'none',
    canvas:                         'canvas'
};

OEPDFViewPageRenderMode.all = Object.keys(OEPDFViewPageRenderMode);

//
export const OEPDFViewProps = {

    pagePropTypes:   {
        debugOutEnabled:            PropTypes.bool,
        className:                  PropTypes.string,
        pageNumber:                 PropTypes.number,
        visible:                    PropTypes.bool,
        layoutWidth:                PropTypes.number,
        scaleMode:                  PropTypes.oneOf(OEPDFViewScaleMode.all),
        renderMode:                 PropTypes.oneOf(OEPDFViewPageRenderMode.all),
        layoutSizeIsChanging:       PropTypes.bool,
        onLoaded:                   PropTypes.func,
        onRendered:                 PropTypes.func
    },

    pageDefaultProps: {
        debugOutEnabled:            false,
        className:                  '',
        pageNumber:                 0,
        visible:                    true,
        scaleMode:                  OEPDFViewScaleMode.explicit,
        renderMode:                 OEPDFViewPageRenderMode.canvas,
        layoutSizeIsChanging:       false
    },

    propTypes: {
        debugOutEnabled:            PropTypes.bool,
        className:                  PropTypes.string,
        fileURL:                    PropTypes.string,
        pageIndex:                  PropTypes.number,
        page:                       PropTypes.number,
        layoutToPageHeight:         PropTypes.bool,
        options:    PropTypes.shape({
            scaleMode:              PropTypes.oneOf(OEPDFViewScaleMode.all),
            dynamic:                PropTypes.bool.isRequired,
        }),
        errorStr:                   PropTypes.string,
        onDocumentStateChanged:     PropTypes.func,
        onDocumentPageStateChanged: PropTypes.func,
        onError:                    PropTypes.func
    },

    defaultProps: {
        debugOutEnabled:            false,
        className:                  '',
        fileURL:                    '',
        layoutToPageHeight:         false,
        options: {
            scaleMode:              OEPDFViewScaleMode.explicit,
            dynamic:                true
        }
    }
};